import { render, staticRenderFns } from "./ObservacoesRodape.vue?vue&type=template&id=44e620bb&scoped=true"
import script from "./ObservacoesRodape.vue?vue&type=script&lang=js"
export * from "./ObservacoesRodape.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e620bb",
  null
  
)

export default component.exports